import { createAction } from '@reduxjs/toolkit';

export interface ProjectInfo {
  project: string;
  token: string;
  testing?: string;
  development?: string;
  develpment?: string;
  production?: string;
  [key: string]: string | undefined;
}

export interface AuthUserInfo {
  uid: string;
  email?: string | null;
  displayName?: string | null;
  photoURL?: string | null;
}

export interface RolePagesMap {
  [role: string]: string[];
}

const authAct = {
  SET_TOKEN: createAction<string>(
    'SET_TOKEN',
  ),
  CLEAR_TOKEN: createAction<null>(
    'CLEAR_TOKEN',
  ),
  SET_PRJ_TOKEN: createAction<ProjectInfo[]>(
    'SET_PRJ_TOKEN',
  ),
  CLEAR_PRJ_TOKEN: createAction<null>(
    'CLEAR_PRJ_TOKEN',
  ),
  SET_USER: createAction<AuthUserInfo | null>(
    'SET_USER',
  ),
  CLEAR_USER: createAction<null>(
    'CLEAR_USER',
  ),
  SET_ROLE: createAction<string>(
    'SET_ROLE',
  ),
  SET_ROLE_PAGES: createAction<RolePagesMap>(
    'SET_ROLE_PAGES',
  ),
  SET_AUTH_READY: createAction<boolean>(
    'SET_AUTH_READY',
  ),
};
export default authAct;
